module.exports = __webpack_public_path__ + "assets/img/effective5.1bae9b89.png";